/**
@description 公共部分的布局
*/
import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
//app level
import { Header } from './Header'
import LeftNavigation from 'components/layout/LeftNavigation'
import { Foot } from './Foot'//Footer
import Breadcrumb from 'components/layout/Breadcrumb'
import {actions} from 'components/layout/layoutModule'
import composeHOC from 'shared/utils/composeHOC'
import preload from 'components/enhancer/preload'
///*
import './DefaultLayout.scss'
import './scss/reset.scss'
import './scss/common.scss'
import './scss/index.scss'

class CoreLayout extends React.Component {

  constructor(props) {
    super(props)
  }

  componentDidMount() {
    //控制左侧菜单sticky fixed
    function leftMenu(){
      var buyT=0
      var oF=$('.leftBar')
      if(!oF.offset()) return false
      buyT=oF.offset().top
      $(window).scroll(function(){
        var navHeight=$('.leftBar ').height()
        var top=$(document).scrollTop()
        var scrollHeight=($('#page_Detail').outerHeight()+$('#page_Detail').offset().top)-$('.leftBar').outerHeight()
        var winScroll=$(window).scrollTop()
        var widthscreen=$(window).width()
        var mainWidth=$('.page_detail .area').width()
        var rightWidth=(widthscreen-mainWidth)/2
        var mainRight=$('.page_detail .area').offset() && $('.page_detail .area').offset().left
        var maxWidth=1024 //当屏幕大于1024
        if(winScroll>buyT)
        {
          if(rightWidth<0)
          {
            $('.leftBar').css({'width':'240px','position':'fixed','top':'0','left':mainRight})

          }else{
            $('.leftBar').css({'width':'240px','position':'fixed','top':'0','left':rightWidth })
          }
        }
        else
        {
          $('.leftBar').css({'width':'240px','position':'absolute','top':'0','left':'0'})
        }
        if(top>scrollHeight)
        {
          $('.leftBar').css({'width':'240px','position':'absolute','top':scrollHeight-($('#page_Detail').offset().top+2),'left':'0'})
        }
      })
    }
    leftMenu()
  }






  render() {//每次路由时候会执行

    const {children, preload, router, menus, routes,friendshipLink,location} = this.props//当前属性
    const ChildInstance = React.Children.only(children)//模块的内容
    const { left, right, title, breadcrumb } = ChildInstance.type//获取模块的信息

    let leftMenu = null //默认无，除非找到对应显示列表
    if (menus) {
      menus.forEach((menu) => {
        if (router.isActive(menu.catname)) {//是否是当前命中路由
          leftMenu = menu//从所有的菜单配置中找到当前页面的菜单列表
        }
      })
    }

    return (
      <div className="layout-container">
        {/* { preload && preload.pending && (<div className="preloading"></div>) } */}
        <Header {...this.props} right={right} title={title} left={left} />{/**头部导航*/}
        <div className="wrap page_detail" id="page_Detail">
          {ChildInstance}{/**路由到的模块内容*/}
        </div>
        <Foot menus={menus} friendshipLink={friendshipLink} pathname={location.pathname} />{/**底部*/}
      </div>
    )
  }
}

const menuChilderUrl=(catname,childCatname,isLoanInfo='',isFooter=false)=>{
  let locations=window.location && window.location.host.split('.')
  if((locations && !/^(ztx2|ztx1|127|localhost)$/.test(locations[0])) || !locations){
    let page=(isLoanInfo=='loaninfo' && (childCatname=='news' ))?'/list-1.html':''
    let childerUrl=''
      childerUrl=(childCatname=='loaninfo' || catname=='')?'':'/'+catname+ '/' +(childCatname=='news'?'newsinfo':childCatname)

    return (isFooter?'http://':'https://')+((isFooter || childCatname=='loaninfo' )?footerPrefixUrlChilder(childCatname):'www')+".chinatopcredit.com"+childerUrl+page

  }else if(isLoanInfo==''){
    return catname!=''?('/' + catname + '/' + childCatname):'/'
  }else{
   return '/' + catname + '/' + childCatname+(/^(loaninfo)$/.test(childCatname)?'/list-1.html':'')
  }
}
const footerPrefixUrlChilder=(catname)=>{
  switch (catname){
    case 'loanHelp':
    return 'apply'

    case 'aboutSigned':
    return 'signed'

    case 'aboutRepayment':
    return 'repay'

    case 'loanTerm':
    return 'loanterm'

    case 'loanQuota':
    return 'quota'

    case 'loanRate':
    return 'loanrate'

    case 'loanApply':
    return 'apply'

    case 'product':
    return 'xqd'

    case 'policyLoan':
    return 'bdd'

    case 'entrepreneurLoan':
    return 'yyd'

    case 'goodCreditLoan':
    return 'xyd'

    case 'payPeriodLoan':
    return 'xqd'

    case 'creditCardLoan':
    return 'xykd'

    case 'educationLoan':
    return 'xld'

    case 'recruitment':
    return 'job'

    case 'jobRecruitment':
    return 'job'

    case 'compensationAndBenefits':
    return 'benefits'

    case 'trainingDevalopment':
    return 'training'

    case 'office':
    return 'office'

    case 'aboutUs':
    return 'aboutus'

    case 'loaninfo':
    return 'info'

    case 'honor':
    return 'honor'

    case 'shopAddress':
    return 'address'

    case 'partner':
    return 'partner'

    case 'management':
    return 'management'

    case 'news':
    return 'news'

    case 'newsinfo':
    return 'news'

    case 'loaninfodetail':
    return 'info'

    case 'company':
    return 'aboutus'

    default :
    return 'www'
  }
}

const prefixUrlChilder=(catname)=>{
    return 'www'
}

const mapStateToProps = (state) => {
  return {
    menus: state.common.menus,
    preload: state.preload,
    friendshipLink:state.common.friendshipLink,
  }
}

export default composeHOC(
  connect(mapStateToProps, actions),
  preload(({dispatch}) => {
    return Promise.all([
      dispatch(actions.getHomeConfigs()),//产品广告
      dispatch(actions.getMenus())//获得所有菜单导航
    ])
  })
)(CoreLayout)



// WEBPACK FOOTER //
// ./components/layout/DefaultLayout.js